export const Pattern = Object.freeze({
  cardBid: /(100\.\d{1,3}\.\d{1,3}.\d{1,3})/,
});
